import React from 'react';
import { Hero } from '../components/Hero';
import { Portfolio } from '../components/Portfolio';
export const HomePage = () => {
  return <>
      <Hero data-id="element-226" />
      <Portfolio data-id="element-227" />
    </>;
};